import React from 'react';
import processImg from '../../assets/process.gif';

interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
    children: React.ReactNode;
    onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
    className?: string;
    isProcessing?: boolean;
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const { children, onClick, className, isProcessing = false, type = 'button', ...rest } = props;
    const focusClasses =
      'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50';
    const defaultClasses = `px-2 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 ${focusClasses}`;
    const resolvedClassName =
      className && className.trim().length > 0
        ? `${className.trim()} ${focusClasses}`
        : defaultClasses;
    return (
      <button type={type} ref={ref} onClick={onClick} className={resolvedClassName} {...rest}>
        {!isProcessing ? children : <img src={processImg} className="w-4 h-4" alt="Processing..." />}
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;